import ConnectedBrand from './ConnectedBrand';

export default ConnectedBrand;
